import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import TransactionList from '@/shared/components/TransactionList/TransactionList';
import styles from './Transactions.module.css';
import TransactionListControl from '@/shared/components/TransactionListControl/TransactionListControl';
import PaginationControl from '@/shared/components/PaginationControl';
import { useState } from 'react';
import _ from 'lodash';
import { useTransactions } from '@/shared/hooks/transactions';
import { t } from 'i18next';
import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { withTranslation } from 'react-i18next';

const MAX_TRANSACTIONS_PER_PAGE = 10;

const Transactions: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { transactions, isLoading } = useTransactions();

  const transactionsForCurrentPage = transactions?.slice(
    (currentPage - 1) * MAX_TRANSACTIONS_PER_PAGE,
    currentPage * MAX_TRANSACTIONS_PER_PAGE
  );

  return (
    <PageWrapper name="transactions-page" mainPage={true}>
      <IonGrid fixed={true}>
        <IonRow>
          <IonCol className={styles.transactionsHeaderColumn}>
            <h1>{t('transactions.title')}</h1>
          </IonCol>
        </IonRow>
      </IonGrid>
      <TransactionListControl />
      <TransactionList isLoading={isLoading} transactions={transactionsForCurrentPage} />
      <PaginationControl
        className={styles.paginationControl}
        currentPage={currentPage}
        numberOfPages={_.ceil((transactions?.length || 0) / MAX_TRANSACTIONS_PER_PAGE)}
        onPageChange={setCurrentPage}
      />
    </PageWrapper>
  );
};

export default withTranslation()(Transactions);
